WiseMetering.Views.Indicator = WiseMetering.Views.Content.extend({
    icon: 'indicators',

    initialize({ model, view }) {
        this.tabs = [
            {
                active: view === 'details',
                href: `/indicators/${model.id}/details`,
                id: 'details',
                name: i18next.t('common.details'),
                view: WiseMetering.Views.IndicatorDetailsTab
            },
            {
                active: view === 'plot',
                href: `/indicators/${model.id}/plot`,
                id: 'plot',
                name: i18next.t('common.plot'),
                view: WiseMetering.Views.IndicatorDashboard
            }
        ];

        if (this.model.alarms().length) {
            this.tabs.push({
                active: view === 'events',
                href: `/indicators/${model.id}/events`,
                id: 'events',
                name: i18next.t('glossary.events'),
                view: WiseMetering.Views.IndicatorEvents
            });
        }

        if (this.model.utilityKind()) {
            const
                hasPermissions = WiseMetering.Permissions.hasPlanPermissions('objectives'),
                viewName = hasPermissions ? 'IndicatorObjectives' : 'NoAccess',
                title = hasPermissions ? i18next.t('glossary.objectives') : `${WiseMetering.icon('lock')} ${i18next.t('glossary.objectives').capitalize()}`;

            this.tabs.push({
                active: view === 'objectives',
                href: `/indicators/${model.id}/objectives`,
                id: 'objectives',
                name: title,
                view: WiseMetering.Views[viewName]
            });
        }

        if (this.model.buckets().length && WiseMetering.currentUser.get('manager') && this.model.get('type') !== 'mirror') {
            this.tabs.push({
                active: view === 'data',
                href: `/indicators/${model.id}/data`,
                id: 'data',
                name: i18next.t('common.data'),
                view: WiseMetering.Views.IndicatorMetals
            });
        }
    }
});
